var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"titulo-lateral"},[_c('h2',[_vm._v(_vm._s(_vm.titulo))]),(_vm.temBotao)?_c('a',{attrs:{"href":_vm.link}},[_vm._v("VER MAIS")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }